module.exports = __webpack_public_path__ + "media/images/flags/64/Libya-fd30c291bdb18e6398117bda7a209004.png";